import { buildExternalSearchController, performAlgoliaTextSearch } from "@firecms/firebase";
import { algoliasearch, SearchClient } from "algoliasearch";

const client: SearchClient | undefined = algoliasearch(
  "4JZQM8X0ZH",
  "6f7dd20eb4fe3073596233d47aff61b2",
);
export const algoliaSearchControllerBuilder = buildExternalSearchController({
  isPathSupported: (path) => {
    return ["connections", "team", "nexhealth"].includes(path);
  },
  search: async ({ path, searchString }) => {
    if (path === "connections")
      return performAlgoliaTextSearch(client, "connections", searchString);
    if (path === "team") return performAlgoliaTextSearch(client, "team", searchString);
    if (path === "nexhealth") return performAlgoliaTextSearch(client, "nexhealth", searchString);
    return undefined;
  },
});
